export default __webpack_public_path__ + "static/experienced-e60e3a449ae1bfd2e1ab72f09385f480.webp";